import { z } from "zod";

export const checklistCategoryEnum = z.enum(["Monthly Inspection Report", "User Acceptance"]);

export const checklistSchema = z.object({
	id: z.number().optional(),
	name: z.string().min(1, "Name is required"),
	description: z.string().optional().nullable(),
	category: checklistCategoryEnum,
	project_id: z.number().optional().nullable(),
	project: z
		.object({
			id: z.number(),
			name: z.string(),
			client: z.string().optional().nullable(),
			status: z.string(),
		})
		.optional()
		.nullable(),
	created_at: z.string().optional().nullable(),
	updated_at: z.string().optional().nullable(),
	deleted_at: z.string().optional().nullable(),
});

export type Checklist = z.infer<typeof checklistSchema>;
export type ChecklistCategory = z.infer<typeof checklistCategoryEnum>;

export const checklistCategoryOptions = [
	{ value: "Monthly Inspection Report", label: "Monthly Inspection Report" },
	{ value: "User Acceptance", label: "User Acceptance" },
] as const;
